const StatisticalEmp = () =>
  import('@/views/main/promotion/statiticalEmp/StatisticalEmp.vue')
export default {
  path: '/main/promotion/statiticalEmp',
  name: 'PromotionStatisticalEmp',
  component: StatisticalEmp,
  children: []
}
